import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateCapitalUnderline
} from '@/util/validate'


export const engineerOrderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "商品名称",
            prop: "goodsName",
            type: "input",
            editVisdiplay: false
        },
        {
            label: "筛选",
            prop: "searchParams",
            type: "input",
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            viewVisdiplay:false
        },
        {
            label: "订单编号",
            prop: "orderNumber",
            editVisdiplay: false
        },
        {
            label: "购买个数",
            prop: "goodsCount",
            editVisdiplay: false
        },
        {
            label: "订单金额",
            prop: "orderAmount",
            editVisdiplay: false
        },
        {
            label: "平台抽成金额",
            prop: "platformAmount",
            editVisdiplay: false
        },
        {
            label: "订单状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: DIC.ORDER_STATUS,
            editVisdiplay: false
        },
        {
            label: "下单人姓名",
            prop: "realName",
            editVisdiplay: false
        },
        {
            label: "下单人电话",
            prop: "orderMobile",
            editVisdiplay: false
        },
        {
            label: "下单时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "收货人名称",
            prop: "name",
            editVisdiplay: false
        },
        {
            label: "收货人电话",
            prop: "mobile",
            editVisdiplay: false
        },
        {
            label: '省份',
            prop: 'province',
            type: 'select',
            hide: true,
            formsolt: true,
            editVisdiplay: false
        },
        {
            label: '城市',
            prop: 'city',
            type: 'select',
            hide: true,
            formsolt: true,
            editVisdiplay: false
        },
        {
            label: '地区',
            prop: 'area',
            type: 'select',
            hide: true,
            formsolt: true,
            editVisdiplay: false
        },
        {
            label: "详细地址",
            prop: "address",
            editVisdiplay: false
        },
        {
            label: "配送方",
            prop: "deliveryMan",
            editVisdiplay: false
        },
        {
            label: "配送类型",
            prop: "deliveryType",
            editVisdiplay: false,
            dicData: DIC.DELIVERY_TYPE
        },
        {
            label: "配送金额",
            prop: "deliveryAmount",
            editVisdiplay: false
        },
        // {
        //     label: "运单号",
        //     prop: "expressNumber",
        // },
        {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "商品图片",
            prop: "img",
            span: 24,
            // hide: true,
            solt: true,
            formsolt: true,
            editVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请上传商品图片"
            }]
        } 
        , {
            label: '物流公司',
            prop: 'deliveryId',
            formsolt: true,
            hide: true,
            editVisdiplay: false
        }, {
            label: '快递单号',
            prop: 'expressNumber',
            hide: true,
            editVisdiplay: false

        }, {
            label: '快递费用',
            prop: 'amount',
            hide: true,
            editVisdiplay: false
        }, {
            label: '配送经销商',
            prop: 'merchantDeliveryId',
            formsolt: true,
            hide: true,
            editVisdiplay: true
        }, {
            label: '配送费比例',
            prop: 'amount',
            hide: true,
            editVisdiplay: true,
        }
    ]
};